import React, { useEffect, useRef, useState } from 'react';
import { Carousel as AntCarousel, CarouselProps as AntCarouselProps } from 'antd';
import styled from 'styled-components';
import UiKit from '../../ui-kit';

interface CarouselProps extends AntCarouselProps {
  title?: string;
  topButton?: boolean;
}

function Carousel({ title, topButton, children, ...rest }: CarouselProps) {
  const carouselRef = useRef<React.ElementRef<typeof AntCarousel>>(null);

  // Обработчики для переключения слайдов
  const handlePrev = () => {
    carouselRef.current?.prev();
  };

  const handleNext = () => {
    carouselRef.current?.next();
  };

  return (
    <Wrapper>
      <Head>
        <UiKit.Text type="secondary">{title}</UiKit.Text>
        {topButton && (
          <HeadAction>
            <UiKit.Button
              onClick={handlePrev}
              icon={<UiKit.icons.Left />}
              type="text"
            ></UiKit.Button>
            <UiKit.Button
              onClick={handleNext}
              icon={<UiKit.icons.Right />}
              type="text"
            ></UiKit.Button>
          </HeadAction>
        )}
      </Head>
      <StyledCarousel ref={carouselRef} {...rest}>
        {children}
      </StyledCarousel>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Head = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 32px 0px 16px 0px;
`;

const HeadAction = styled.div`
  display: flex;
`;

const StyledCarousel = styled(AntCarousel)``;

export { Carousel };
